module.exports = __webpack_public_path__ + "media/components/icons/SVG/info-squared-43c69abbd6dac2fd7734cd1b61bf631d.svg";